var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg-top"}),_c('div',{staticClass:"wrapper"},[_c('main-nav'),_c('page-hero'),_c('page-intro'),_c('page-about'),_c('page-project'),_c('page-skill')],1),_c('page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }